// extracted by mini-css-extract-plugin
export default {"menuBlock":"uG-z","title":"vG-z","nav":"wG-z","flexCell":"xG-z","facetLink":"yG-z"};